import * as React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput';
import { useGetOwnerIndex } from '../../hooks/useGetOwnerIndex';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip';
import { sourceTooltip } from '../../constants';
import { commonStyles } from '~/theme/styles/commonStyles';

interface IFreeFloatOwnerFormProps {
  index: number;
  handlePercentageChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export const FreeFloatOwnerForm = ({ index, handlePercentageChange }: IFreeFloatOwnerFormProps) => {
  const { ownerIndex } = useGetOwnerIndex(index);
  return (
    <Grid container spacing={3} sx={{ width: '100%' }}>
      <FormGridItem>
        <FormInput
          name={`owners.${ownerIndex}.fullName`}
          placeholder="Введіть назвау"
          label="Назва"
          fullWidth
          disabled
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`owners.${ownerIndex}.sourceURL`}
          placeholder="https://"
          label={
            <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
              <Typography variant="body2">Джерело (посилання на біржу)</Typography>
              <InfoTooltip title={sourceTooltip} />
            </Box>
          }
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`link.${index}.ownershipPercentage`}
          placeholder="Введіть частку в статутному капіталі"
          label="Частка в статутному капіталі (%)"
          fullWidth
          onChange={handlePercentageChange}
          disableFormOnChange
        />
      </FormGridItem>
    </Grid>
  );
};
